const ORDEN_COMPRAS = (state, orden_compras) => {
    state.orden_compras = orden_compras;
};

const FETCH = (state, fetch) => {
    state.fetch = fetch;
};


export default {
    ORDEN_COMPRAS,
    FETCH,
};